import React, { Component } from "react";
import cn from "classnames";
import "./Layout.less";

const CLASS_NAME = "fct-layout";
class Layout extends Component {
  render() {
    const {
      children,
      disabled,
      invalid,
      invisible,
      scrollable,
      scrollx,
      scrolly,
      width,
      height,
      _lgap,
      _rgap,
      _tgap,
      _bgap,
      _hgap,
      _vgap,
      left,
      right,
      top,
      bottom,
      lgap,
      rgap,
      tgap,
      bgap,
      hgap,
      vgap,
      style = {},
      className,
      baseCls,
      extraCls,
      cls,
      ...props
    } = this.props;
    return (
      <div
        {...props}
        className={cn(CLASS_NAME, baseCls, extraCls, className, cls, {
          "base-disabled disabled": disabled,
          "base-invalid invalid": invalid
        })}
        style={{
          ...{
            overflowX:
              !scrollable &&
              scrollx != null &&
              (scrollx === true ? "auto" : "hidden"),
            overflowY:
              !scrollable &&
              scrolly != null &&
              (scrolly === true ? "auto" : "hidden")
          },
          ...(scrollable != null && {
            overflow: scrollable ? "auto" : "hidden"
          }),
          ...(scrollx && { overflowY: "hidden" }),
          ...(scrolly && { overflowX: "hidden" }),
          ...(invisible === true && { display: "none" }),
          ...(disabled === true && { pointerEvents: "none" }),
          width,
          height,
          ...(left != null && {
            left
          }),
          ...(right != null && {
            right
          }),
          ...(top != null && {
            top
          }),
          ...(bottom != null && {
            bottom
          }),
          ...style,
          ...((_lgap || _hgap || style.marginLeft) && {
            marginLeft:
              (_lgap ? _lgap : 0) +
              (_hgap ? _hgap : 0) +
              (style.marginLeft || 0)
          }),
          ...((_rgap || _hgap || style.marginRight) && {
            marginRight:
              (_rgap ? _rgap : 0) +
              (_hgap ? _hgap : 0) +
              (style.marginRight || 0)
          }),
          ...((_tgap || _vgap || style.marginTop) && {
            marginTop:
              (_tgap ? _tgap : 0) + (_vgap ? _vgap : 0) + (style.marginTop || 0)
          }),
          ...((_bgap || _vgap || style.marginBottom) && {
            marginBottom:
              (_bgap ? _bgap : 0) +
              (_vgap ? _vgap : 0) +
              (style.marginBottom || 0)
          })
        }}
      >
        {children}
      </div>
    );
  }
}

export default Layout;



// WEBPACK FOOTER //
// ./layout/Layout.js